import React from 'react';
import {Box} from '@mui/material';
import moment from 'moment-timezone';

import MemberIdChipWithTags from './MemberIdChipWithTags';
import {TWENTY_FOUR_HOUR_TIME_FORMAT} from '../../config/DateTimeConstants';
import {
    buildMemberStatusColorCode,
    buildMemberStatusMessage,
    evaluateSessionTiming,
    MAX_CHILDREN_TO_DISPLAY,
    SESSION_JOIN_STATUS_MESSAGE
} from '../../helpers/SessionHelper';

const styles = {
    box: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
        },
    },
};

const NUMBER_OF_SEATS_TO_SHOW_MEMBER_JOINING_TIME = 1;
const TIMESTAMP_DATA_UNAVAILABLE = '-';

const buildChildStatusInfo = (child, session, sessionStartTime, sessionEndTime, sessionSeatCount, firstChildJoinTime, timezone) => {
    const memberId = child.parent?.externalId || '';
    const seat = session.seats?.find(seat => seat.booking?.child?.parent?.externalId === memberId);
    const bookingStatus = seat?.booking?.status;
    const attendanceReport = seat?.booking?.attendedSessionReport;

    const memberJoiningTime = firstChildJoinTime
        ? moment(firstChildJoinTime).format(TWENTY_FOUR_HOUR_TIME_FORMAT)
        : TIMESTAMP_DATA_UNAVAILABLE;

    const {isUpcomingSession} = evaluateSessionTiming(sessionStartTime, sessionEndTime, timezone);
    const statusColor = buildMemberStatusColorCode(bookingStatus, sessionStartTime, sessionEndTime, timezone);
    const statusMessage = buildMemberStatusMessage(statusColor, isUpcomingSession);
    const showMemberJoiningTime = statusMessage === SESSION_JOIN_STATUS_MESSAGE.MEMBER_JOINED
        && sessionSeatCount === NUMBER_OF_SEATS_TO_SHOW_MEMBER_JOINING_TIME;

    return {
        memberId,
        seat,
        statusColor,
        statusMessage,
        showMemberJoiningTime,
        memberJoiningTime,
        attendanceReport
    };
};

const MemberStatusCell = ({ children, session, timezone, onChildDetailsDrilledInto }) => {
    if (!children || children.length === 0 || children.length > MAX_CHILDREN_TO_DISPLAY) {
        return null;
    }

    const sessionStartTime = session.from;
    const sessionEndTime = session.to;
    const sessionSeatCount = session.seats?.length || 0;
    const firstChildJoinTime = session.firstChildJoinTime;

    return (
        <Box sx={styles.box.container}>
            {children.map((child) => {
                const {
                    memberId,
                    seat,
                    statusColor,
                    statusMessage,
                    showMemberJoiningTime,
                    memberJoiningTime,
                    attendanceReport
                } = buildChildStatusInfo(child, session, sessionStartTime, sessionEndTime, sessionSeatCount, firstChildJoinTime, timezone);

                const bookingId = seat?.booking?.id;

                return (
                    <MemberIdChipWithTags
                        key={child.id}
                        child={child}
                        statusColor={statusColor}
                        statusMessage={statusMessage}
                        showMemberJoiningTime={showMemberJoiningTime}
                        memberJoiningTime={memberJoiningTime}
                        memberId={memberId}
                        session={session}
                        bookingId={bookingId}
                        attendanceReport={attendanceReport}
                        onChildDetailsDrilledInto={onChildDetailsDrilledInto}
                    />
                );
            })}
        </Box>
    );
};

export default MemberStatusCell;
